import React from 'react'

import SearchForm from '../search/SearchForm/SearchForm.jsx'
import SearchFormBar from '../search/SearchForm/SearchFormBar.jsx'
import SearchInputField from '../search/SearchInputField/SearchInputField.jsx'
import SearchSubmitButton from '../search/SearchSubmitButton/SearchSubmitButton.jsx'

import SearchFormCondensed from '../search/SearchFormCondensed/SearchFormCondensed.jsx'

// import './BCSuppliersForm.scss';

import locationIcon from './location_icon.svg'

const BCSuppliersForm = ({
  lexicon,
  location,
  setLocation,
  onSearch,
  isCondensed = false,
  setIsCondensed = () => {},
  showTitle = true,
}) => {
  const isSearchSubmitDisabled = location.trim().length === 0

  return (
    <div className={`BCSuppliersForm ${isCondensed ? 'condensed' : ''}`}>
      {isCondensed ? (
        <SearchFormCondensed
          searchValues={[location]}
          onEdit={() => setIsCondensed(false)}
          lexicon={lexicon}
        />
      ) : (
        <SearchForm
          title={showTitle ? lexicon.get('title') : ''}
          forceStacked={false}
        >
          <SearchFormBar forceStacked={false}>
            <SearchInputField
              value={location}
              setValue={setLocation}
              label={lexicon.get('location_label')}
              placeholder={lexicon.get('location_placeholder')}
              icon={locationIcon}
              forceStacked={false}
            />
          </SearchFormBar>

          <SearchSubmitButton
            searchLocation={location}
            setSearchLocation={setLocation}
            text={lexicon.get('search')}
            onClick={onSearch}
            forceStacked={false}
            disabled={isSearchSubmitDisabled}
          />
        </SearchForm>
      )}
    </div>
  )
}

export default BCSuppliersForm
